import { useState, useCallback } from 'react';
import axios from 'axios';
import get from 'lodash/get';

const { REACT_APP_GEOCODE_API_KEY: geocodeApiKey } = process.env;

export default function useAddress () {
  const [isLoading, setIsLoading] = useState(false);

  const getAddressFromPostalCode = useCallback(async postalCode => {
    if (!postalCode || postalCode.length !== 8) {
      return null;
    }
    setIsLoading(true);
    try {
      const { data } = await axios.get(`https://viacep.com.br/ws/${postalCode}/json`);
      const { logradouro: street, bairro: neighborhood, localidade: city, uf: state, erro } = data;
      if (!erro) {
        return { street, neighborhood, city, state, postalCode };
      }
    } catch (err) {
      throw err;
    } finally {
      setIsLoading(false);
    }
  }, []);

  const getLatLngFromAddress = useCallback(async address => {
    if (typeof address !== 'object' || !address.street) {
      throw new Error('Endereço inválido');
    }

    setIsLoading(true);
    try {
      const { street, number, city, state, postalCode } = address;
      const params = { street, housenumber: number, city, state, country: 'Brazil', postcode: postalCode };
      const { data } = await axios.get('https://api.geoapify.com/v1/geocode/search', { params: { ...params, type: 'locality', apiKey: geocodeApiKey } });
      const coords = get(data, 'features[0].geometry.coordinates', []);
      return { lat: coords[1], lng: coords[0] };
    } catch (err) {
      throw new Error(err?.message || 'Localização não encontrada');
    }
    finally {
      setIsLoading(false);
    }
  }, []);

  return { isLoading, getAddressFromPostalCode, getLatLngFromAddress };
}
